<template>
  <router-view />
</template>

<script>
export default {
  name: 'Brands',
}
</script>
